import React from 'react'

import Header from '../component/header'
import BannerImg from '../image/education.png'
import Banner from '../component/Banner'
import Footer from '../component/Footer'
function TermsConditions() {
    return (

        <>
         <Header />
          <Banner
            backgroundImage={BannerImg}
            heading="Terms and Conditions"
            paragraph="Lightweave Beacon Legacy believes that every artist deserves guidance, not from gatekeepers, but from mentors, peers, and shared learning. Our education programs provide structured study, tutorials, critique insights, and learning materials designed to elevate the craft across architecture, photography, sculpture, and technical design. Whether emerging or experienced, this is where creative skill matures into mastery."
            minHeight="100vh"
            padding="80px 0"
            bton="Members please sign-in"
          />
          
            <div className="max-w-4xl mx-auto py-16 px-6 text-gray-800 leading-relaxed font-outfit">

                <h1 className="text-4xl font-cinzel mb-6">Terms & Conditions</h1>
                <p className="mb-4">Last updated: January 2025</p>

                <p className="mb-6">
                    Welcome to <strong>[Organization Name]</strong> (“we,” “our,” or “us”). By accessing or using
                    <strong> [Website URL]</strong> (the “Site”), you agree to comply with and be bound by the following Terms
                    & Conditions. Please read them carefully before using our services, digital platforms, or membership programs.
                </p>

                {/* Section 1 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">1. Acceptance of Terms</h2>
                <p>
                    By using the Site, creating an account, joining a membership, submitting artwork, or participating in our
                    programs, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.
                </p>

                {/* Section 2 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">2. Eligibility</h2>
                <p>You must be at least 13 years old to use our services. By using the Site, you represent that:</p>
                <ul className="list-disc ml-6 mt-2">
                    <li>You are legally able to form a binding contract</li>
                    <li>You will use the Site only for lawful purposes</li>
                    <li>All information you provide is accurate and complete</li>
                </ul>

                {/* Section 3 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">3. User Accounts</h2>
                <p>When creating an account, you agree to:</p>
                <ul className="list-disc ml-6 mt-2">
                    <li>Provide accurate and current information</li>
                    <li>Keep your login credentials secure</li>
                    <li>Notify us immediately of unauthorized access</li>
                    <li>Accept responsibility for all activities under your account</li>
                </ul>

                {/* Section 4 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">4. Membership & Subscriptions</h2>
                <p>Purchasing a membership grants access to exclusive content, galleries, events, and services. You agree that:</p>
                <ul className="list-disc ml-6 mt-2">
                    <li>Membership fees are billed according to the chosen plan</li>
                    <li>Some memberships renew automatically unless canceled</li>
                    <li>Refunds are subject to the refund policy</li>
                </ul>

                {/* Section 5 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">5. Artwork & Content Submissions</h2>
                <p>By submitting artwork, photography, writing, or other content to the Site, you grant us permission to:</p>
                <ul className="list-disc ml-6 mt-2">
                    <li>Display your content in galleries and community spaces</li>
                    <li>Use content for promotional and educational purposes (with attribution)</li>
                    <li>Store and process your submissions for review and curation</li>
                </ul>
                <p className="mt-2">
                    You maintain full ownership of your work. We do not claim intellectual property rights over your submissions.
                </p>

                {/* Section 6 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">6. Prohibited Activities</h2>
                <p>You agree not to engage in any of the following:</p>
                <ul className="list-disc ml-6 mt-2">
                    <li>Uploading harmful, offensive, or illegal content</li>
                    <li>Attempting to access or compromise another user's account</li>
                    <li>Interfering with the Site’s security or performance</li>
                    <li>Using the Site for commercial advertising without permission</li>
                </ul>

                {/* Section 7 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">7. Payment & Billing</h2>
                <p>
                    All payments are processed securely through trusted third-party payment providers.
                    We do not store full credit card information.
                </p>
                <p className="mt-2">
                    You agree to provide accurate billing information and authorize charges for memberships, purchases, or donations.
                </p>

                {/* Section 8 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">8. Intellectual Property</h2>
                <p>
                    All site content, images, design elements, branding, graphics, and digital assets created by
                    <strong> [Organization Name]</strong> are protected by copyright and may not be copied, reproduced, or
                    distributed without permission.
                </p>

                {/* Section 9 */}
                <h2 className="text-2xl font-cinzel mt-10 mb-3">9. Termination of Access</h2>
                <p>
                    We reserve the right to suspend or terminate access to the Site or membershi
                </p>
            </div>
            <Footer />
            </>
    )
}

export default TermsConditions